import React, { useEffect, useRef, useState } from "react";
import { PageInfoHeader } from "../../../component/comman/PageInfoHeader";
import {fDateUTC } from "../../../utils/helper/timeHelpers";
import { getCustomers } from "../../../action/customersAction";
import { USERTYPE_ENUM } from "../../../utils/Constant";
import { formatFileURL } from "../../../utils/helper/appHelpers";
import logo from "../../../assets/profile.png";
import { _vendorAdminRoutes } from "../../../utils/appRouter";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../comman/Pagination";
import CustomerDetailsModal from "../customers/CustomerDetailsModel";




const _modelName = {
  customerDetails: "CUSTOMER_DETAILS",
};

const CustomerListing = () => {
   const navigate = useNavigate();
    
    const [isLoading, setIsLoading] = useState(false)
    const [customers, setCustomers] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const limit = 10;
    const [search, setSearch] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const deleteRef = useRef(null);

    const [model, setModel] = useState({ name: "", data: {} })

    const handleModalOpen = (name, data = {}) => setModel({ ...model, name, data })
    const handleModalClose = () => setModel({ ...model, name: null, data: {} })

      useEffect(() => {
      const handler = setTimeout(() => {
        setDebouncedSearch(search);
      }, 300);
    
      return () => clearTimeout(handler);
    }, [search]);
    
     const fetchCustomer = async () => {
        try {
           handleModalClose()
          setIsLoading(true);
          const resp = await getCustomers({
            offset: (page - 1) * limit,
            limit,
            page,
            searchQ: debouncedSearch,
            userType: USERTYPE_ENUM.VENDOR
          });
    
          if (resp?.success) {
            setCustomers(resp.data.rows);
            setTotal(resp.data.total);
          }
        } catch (error) {
        console.log(error);
        }finally{
          setIsLoading(false); 
        } 
      };

      const handleNavigation = (_id) => {
        navigate(_vendorAdminRoutes.customersDetails(_id));
      };
    
      useEffect(() => {
        fetchCustomer();
      }, [page, debouncedSearch]);
    

  return (
    <>
    <section className="content mb-5">
      <div className="container-fluid">
        <div className="row titlepad">
          <div className="col-md-12">
            <div className="mt-3 mb-3">
              <div className="dashbed-border-bottom"></div>
            </div>

            <div className="row align-items-end">
              <div className="col-sm-9">
                <h4> Customers </h4>

                <PageInfoHeader
                  page={page}
                  limit={limit}
                  total={total}
                  label="List of customers"
                />

                {/* <a
                  href={_vendorAdminRoutes.AddCoupon}
                  className="btn-md btn-primary d-inline-block"
                >
                  <i className="fa-solid fa-user-plus"></i> Add More
                </a> */}
                {/* <a
                  onClick={() => handleModalOpen(_modelName.add)}
                  className="btn-md btn-primary d-inline-block"
                  style={{ cursor: "pointer" }}
                >
                  <i className="fa-solid fa-user-plus"></i> Add More
                </a> */}

              </div>

              <div className="col-md-3">
                <input
                  className="form-control searchinput"
                  type="text"
                  placeholder="Search By Customer.."
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setPage(1);
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="mb-3">
              <div className="dashbed-border-bottom"></div>
            </div>
          </div>

          <div className="col-md-12">
            <div className="table-responsive bg-white">
          
               <table className="table table-striped table-bordered admintable border-0">
                <tbody>
                    <tr style={{textAlign : "center"}}>
                    <th>#</th>
                    <th>Image</th>
                    <th>Customer</th>
                    <th>Email</th>
                    <th>Mobile No</th>
                    <th>Created On</th>
                    <th>Status</th>
                    <th>Action</th>
                    </tr>
                    {isLoading ? (
                    <tr>
                        <td colSpan="100%" className="text-center py-4">Loading...</td>
                    </tr>
                    ) : customers?.length > 0 ? (
                    customers.map((customer, index) => (
                        <tr key={customer._id}>
                
                        <td>{(page - 1) * limit + (index + 1)}</td>
                        <td>
                            <img
                                src={
                                    customer?.profilePic
                                    ? formatFileURL(customer?.profilePic)
                                    : logo
                                }
                                width="50px"
                                alt="user"
                            />
                        </td>
                        <td>{customer?.customerId?.userName || "--"}</td>
                        <td>{customer?.customerId?.email || "--"}</td>
                        <td>{customer?.customerId?.dialCode}{customer?.customerId?.mobileNo}</td>
                        <td>{fDateUTC(customer?.customerId?.createdAt, null,  'DD MMM, YYYY')}</td>
                        <td>
                            <span className={`badge ${customer.customerId?.status === "ACTIVE" ? "badge-success" : "badge-danger"}`}>
                            {customer?.customerId?.status}
                            </span>
                        </td>
                          <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                            <a
                              className="f-16"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleModalOpen(_modelName.customerDetails, customer?.customerId)}
                            >
                              <i className="fa-solid fa-eye"></i>
                            </a>
                                <a
                                className="f-16"
                                style={{ cursor: "pointer" }}
                                title="View Orders"
                                onClick={() =>
                                  navigate(_vendorAdminRoutes.orders.list({ customerId: customer?.customerId?._id , customerName: customer.customerId.userName,}))
                                }
                              >
                              <i className="fa-solid fa-box"></i>
                            </a>
                          </td>
                        </tr>
                    ))

                    ) : (
                    <tr>
                        <td colSpan={10} className="text-center py-4">No customers found.</td>
                    </tr>
                    )}
                </tbody>
                </table>
            </div>
          </div>

          <Pagination
            page={page}
            limit={limit}
            total={total}
            onPageChange={(newPage) => setPage(newPage)}
          />

        </div>
      </div>
    </section>
    {model.name === _modelName.customerDetails && (
      <CustomerDetailsModal
        open={true}
        onClose={handleModalClose}
        customerData={model.data}
      />
    )}
    </>
    
    
  );
  


};


export default CustomerListing;
